import { URL } from '../../../../../config'
import { postRequest } from '../../../../../utils/httpRequest'

export const sendInvalidDetailsNotification = function (eventId,details,token) 
{
  const invalidDetailsEndpoint = `/${eventId}/invaliddetails`
  
  const  invalidDetailsURL =  `${URL.event}${invalidDetailsEndpoint}` 
  
  const invalidInfoDetails = {
     eventId,
     details
  }
  console.log('sendInvalidDetailsNotification eventId,details,token',invalidDetailsURL,invalidInfoDetails,token)
  return postRequest(invalidDetailsURL,invalidInfoDetails,token)
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/CorrectEventDetails/api/index.js